import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../lib/firebase";
import type { SmartTagAttachmentFile, VCard } from "../../../types/vcard";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const getLuggageIdentityDocumentsFiles = (
  formData: Partial<VCard>,
): SmartTagAttachmentFile[] => {
  const categorySpecificInfo = formData.categorySpecificInfo;
  if (!isRecord(categorySpecificInfo)) {
    return [];
  }

  const luggage = categorySpecificInfo.luggage;
  if (!isRecord(luggage)) {
    return [];
  }

  const attachments = luggage.attachments;
  if (!isRecord(attachments)) {
    return [];
  }

  const identityDocuments = attachments.identityDocuments;
  if (!isRecord(identityDocuments) || !Array.isArray(identityDocuments.files)) {
    return [];
  }

  return identityDocuments.files as SmartTagAttachmentFile[];
};

export const withLuggageIdentityDocumentsFiles = (
  formData: Partial<VCard>,
  files: SmartTagAttachmentFile[],
): Partial<VCard> => {
  const categorySpecificInfo = isRecord(formData.categorySpecificInfo)
    ? formData.categorySpecificInfo
    : {};
  const luggage = isRecord(categorySpecificInfo.luggage)
    ? categorySpecificInfo.luggage
    : {};
  const attachments = isRecord(luggage.attachments) ? luggage.attachments : {};
  const identityDocuments = isRecord(attachments.identityDocuments)
    ? attachments.identityDocuments
    : {};

  return {
    ...formData,
    categorySpecificInfo: {
      ...categorySpecificInfo,
      luggage: {
        ...luggage,
        attachments: {
          ...attachments,
          identityDocuments: {
            ...identityDocuments,
            files,
          },
        },
      },
    },
  };
};

export const persistLuggageIdentityDocumentsFiles = async (
  userId: string,
  files: SmartTagAttachmentFile[],
): Promise<void> => {
  const vcardRef = doc(db, `users/${userId}/vcards/luggage`);
  await updateDoc(vcardRef, {
    "categorySpecificInfo.luggage.attachments.identityDocuments.files": files,
    updatedAt: serverTimestamp(),
  });
};
